import React from 'react';
import { TypeaheadEntry, CategoryTypeaheadEntry } from './TypeaheadEntry';
import { buildSearchTermUrl } from './urlBuilder.js';
import PropTypes from 'prop-types';

const TypeaheadResults = ({
    searchTerms,
    categories,
    products,
    articles,
    currentSearchTerm,
    searchSubmitLink,
    selected,
    translationUtility
}) => {
    return (
        <div id="typeahead-results">
            <div className="container">
            <div className="row">
                <div className="col-md-6">
                    {categories.length > 0 &&
                        <div
                            id="typeahead-results-categories"
                            className="typeahead-results-list"
                        >
                            <h3>{translationUtility.translateResourceString("/Typeahead/Index/CategoryResultsHeading")}</h3>
                            {categories.map((category, key) => {
                                return (
                                    <CategoryTypeaheadEntry key={key} href={category.Url} name={category.Name} searchTerm={currentSearchTerm} />
                                );
                            })}
                        </div>
                    }
                    {searchTerms.length > 0 &&
                        <div
                            id="typeahead-results-search-terms"
                            className="typeahead-results-list"
                        >
                            <h3>{translationUtility.translateResourceString("/Typeahead/Index/SearchTermResultsHeading")}</h3>
                            {searchTerms.map((searchTerm, key) => {
                                const href = buildSearchTermUrl({ searchSubmitLink, searchTerm });
                                return (
                                    <TypeaheadEntry key={key} href={href} name={searchTerm} searchTerm={currentSearchTerm} />
                                )
                            })}
                        </div>
                    }
                </div>
                <div className="col-md-6">
                    {products.length > 0 &&
                        <div
                            id="typeahead-results-products"
                            className="typeahead-results-list"
                        >
                            <h3>{translationUtility.translateResourceString("/Typeahead/Index/ProductResultsHeading")}</h3>
                            {products.map((product, key) => {
                                return (
                                    <TypeaheadEntry key={key} href={product.Url} name={product.Name} searchTerm={currentSearchTerm} />
                                )
                            })}
                        </div>
                    }
                </div>
                </div>
            </div>
        </div>
    )
}

TypeaheadResults.propTypes = {
    searchTerms: PropTypes.arrayOf(PropTypes.string),
    categories: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string
    })),
    products: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string,
        ImageUrl: PropTypes.string
    })),
    articles: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string
    })),
    currentSearchTerm: PropTypes.string,
    searchSubmitLink: PropTypes.string,
    selected: PropTypes.any
};

export default TypeaheadResults;